const sentMessage = {
  current: null,
}

export default sentMessage;